import { useState, useEffect } from 'react'
import { compactUtm, fetchBotUsername, buildStartLink } from '../../services/utm'
import { useT } from '../../hooks/useTranslation'

// П.5 task.txt: веб-ссылка (https://scalpex.space/?utm_*) открывает приложение
// ВНЕ Telegram — там нет initData и авторизация на бэкенде невозможна, поэтому
// вместо сломанного приложения показываем лендинг с кнопкой «Открыть в Telegram».
// UTM из адресной строки переносится в метку кнопки (компактной кодировкой) —
// атрибуция сохраняется: кнопка ведёт на t.me/<бот>?start=<метка>, бот принимает
// метку и записывает её от настоящего Telegram ID человека (startPayload.js).
export default function WebLanding() {
  const t = useT()

  // База t.me-ссылки — РЕАЛЬНОЕ имя бота с бэкенда (как в генераторе UTM), чтобы
  // кнопка «Открыть в Telegram» не ссылалась на устаревшее зашитое имя. До ответа
  // бэкенда (или при его недоступности) — фолбэк-константа.
  const [botUsername, setBotUsername] = useState(null)
  useEffect(() => {
    let alive = true
    fetchBotUsername().then(u => { if (alive) setBotUsername(u || null) })
    return () => { alive = false }
  }, [])
  let payload = ''
  try {
    const params = new URLSearchParams(window.location.search.slice(1))
    payload = compactUtm({
      source: params.get('utm_source'),
      medium: params.get('utm_medium'),
      campaign: params.get('utm_campaign'),
      term: params.get('utm_term'),
      content: params.get('utm_content'),
    })
  } catch { /* меток нет — просто кнопка без метки */ }

  const href = buildStartLink(botUsername, payload)

  return (
    <div style={{
      minHeight: '100dvh', width: '100%', boxSizing: 'border-box',
      background: '#0A0A0A', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', textAlign: 'center',
      gap: 10, padding: '32px 24px',
    }}>
      <div style={{ fontSize: 46, lineHeight: 1 }}>⚡</div>
      <h1 style={{ fontSize: 22, fontWeight: 800, color: '#fff', margin: 0, letterSpacing: '-0.02em' }}>
        {t.webLandingTitle}
      </h1>
      <p style={{ fontSize: 13.5, color: '#8E8E93', lineHeight: 1.55, margin: 0, maxWidth: 300 }}>
        {t.webLandingSub}
      </p>
      <a
        href={href}
        style={{
          marginTop: 14, padding: '14px 34px', borderRadius: 14,
          background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
          color: '#fff', fontSize: 15, fontWeight: 700, textDecoration: 'none',
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        {t.webLandingBtn}
      </a>
      <p style={{ fontSize: 11, color: '#636366', margin: '10px 0 0', maxWidth: 260, lineHeight: 1.4 }}>
        {t.webLandingHint}
      </p>
    </div>
  )
}
